import { render } from "./AxiosLoading.vue?vue&type=template&id=2dad454a"
import script from "./AxiosLoading.vue?vue&type=script&lang=js"
export * from "./AxiosLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__